export default __webpack_public_path__ + "static/QA-re-teste-ab5eee72ce74f1fc7f11ea16c5a4f347.png";